export default "__VITE_ASSET__B$OZnxIh__"